import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, Calendar } from "lucide-react";
import { useSettings, digitsOnly } from "@/contexts/SettingsContext";
import { useContent } from "@/contexts/ContentContext";

export default function FloatingButtons() {
  const s = useSettings();
  const c = useContent();
  const f = c.floating || {};
  const wa = digitsOnly(s.whatsapp);
  const tel = digitsOnly(s.emergency_phone);
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col gap-3 items-end" data-testid="floating-actions">
      {f.book !== false && (
        <Link to="/book-appointment" className="hidden md:inline-flex btn-primary !py-2 !px-4 text-xs shadow-2xl" data-testid="floating-book-btn">
          <Calendar className="h-3.5 w-3.5" /> Book Appointment
        </Link>
      )}
      {f.whatsapp !== false && (
      <a
        href={`https://wa.me/${wa}?text=Hi%20One%20Hospitals%2C%20I%20would%20like%20to...`}
        target="_blank" rel="noreferrer"
        aria-label="Chat on WhatsApp"
        className="relative h-12 w-12 rounded-full flex items-center justify-center transition hover:scale-105"
        style={{
          background: "linear-gradient(180deg, #2eee7c 0%, #25D366 55%, #1a8f44 100%)",
          boxShadow: "inset 0 1px 0 rgba(255,255,255,0.5), inset 0 -2px 6px rgba(0,0,0,0.3), 0 8px 24px -4px rgba(37,211,102,0.6), 0 0 0 1px rgba(16,247,127,0.3)",
          border: "1px solid rgba(255,255,255,0.18)"
        }}
        data-testid="floating-whatsapp"
      >
        <MessageCircle className="h-6 w-6 text-white drop-shadow" />
      </a>
      )}
      {f.emergency !== false && (
      <a
        href={`tel:${tel}`}
        aria-label="Call emergency helpline"
        className="relative h-14 w-14 rounded-full flex items-center justify-center animate-pulse-ring"
        style={{
          background: "linear-gradient(180deg, #ff5757 0%, #dc2626 55%, #991b1b 100%)",
          boxShadow: "inset 0 1px 0 rgba(255,255,255,0.5), inset 0 -2px 6px rgba(0,0,0,0.3), 0 0 0 1px rgba(255,87,87,0.3)",
          border: "1px solid rgba(255,255,255,0.22)"
        }}
        data-testid="floating-emergency"
      >
        <Phone className="h-6 w-6 text-white drop-shadow" />
      </a>
      )}
    </div>
  );
}
